import { StyleProp } from '@mantine/core';
import * as React from 'react';

export const getAdaptiveWeight = (weight: StyleProp<React.CSSProperties['fontWeight']> | undefined) => {
  switch (weight) {
    case 'normal':
    case '400':
    case 400:
      return '300';
    case 'medium':
    case '500':
    case 500:
      return '400';
    case 'semibold':
    case '600':
    case 600:
      return '500';
    case 'bold':
    case '700':
    case 700:
      return '600';
    default:
      return '300';
  }
};
